import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

import { queryKeys } from 'api/config';

import { useChatInterlocutorContext } from 'features/chat/context/chatInterlocutor';

import { Messages } from '../config/types/Message';

export const useChatQueryActions = () => {
  const queryClient = useQueryClient();
  const { chatId } = useChatInterlocutorContext();

  const queryKey = useMemo(() => [queryKeys.chatMessages, chatId], [chatId]);

  const cancelChatQueries = useCallback(
    async () => await queryClient.cancelQueries(queryKey),
    [queryClient, queryKey]
  );

  const getChatQuery = useCallback(
    () => queryClient.getQueryData(queryKey),
    [queryClient, queryKey]
  );

  const invalidateChatQuery = useCallback(async () => {
    await queryClient.invalidateQueries(queryKey);
  }, [queryClient, queryKey]);

  const updateChatQuery = useCallback(
    (value: Messages) => {
      queryClient.setQueryData(queryKey, value);
    },
    [queryClient, queryKey]
  );

  return {
    cancelChatQueries,
    getChatQuery,
    invalidateChatQuery,
    updateChatQuery,
  };
};
